// extracted by mini-css-extract-plugin
var _1 = "AIButtonContainedLight-moduleaiButtonContainedLight__GOFKi";
var _2 = "AIButtonContainedLight-modulelabel__upufR";
export { _1 as "aiButtonContainedLight", _2 as "label" }
